export const generalKey = 'product_smart_cp100_3'; /**TODO 临时使用，待换 */
// export const whiteLocaleList = ['us'];
// export const productPageUrl = 'ocean-pro-home-solar-battery';
